import React from 'react';
import SEO from '../components/SEO';
import Header from "../partials/header/Header";
import Breadcrumb from '../container/Breadcrumb/Breadcrumb';
import AboutFour from '../container/About/AboutFour';
import Video from '../container/Video/Video';
import AboutFive from '../container/About/AboutFive';
import TestimonialContainer from '../container/Testimonial/TestimonialContainer';
import CallToActionTwo from '../container/CallToAction/CallToActionTwo';
import Footer from '../container/Footer/Footer';
import ScrollToTop from '../components/ScrollToTop.jsx';
import data1 from '../data/content/aboutFourContent';
import data2 from '../data/content/aboutFiveContent';
import CallToActionThree from "../container/CallToAction/CallToActionThree";
import {useLocation} from "react-router-dom";
import data3 from "../data/SEO/seoData";

const DataAnalytics = () => {
    const currentPage = useLocation();
    let seo_data = data3.filter(dataObj => dataObj.path === currentPage.pathname);
    return (
        <React.Fragment>
            <SEO title={seo_data[0].metaTitle} URL={seo_data[0].path} description={seo_data[0].metaDesc} />
            <Header />
            <Breadcrumb
                image={seo_data[0].bcEleImage}
                title={seo_data[0].bcEleTitle}
                content="Home"
                contentTwo="Data Analytics"
            />
            <AboutFour
                mainContent={data1.dataAnalytics.mainContent} mainContent2={data1.dataAnalytics.mainContent2}
                subTitle={data1.dataAnalytics.subTitle}
                title={data1.dataAnalytics.title}
                backgroundImg={data1.dataAnalytics.backgroundImg} foregroundImg={data1.dataAnalytics.foregroundImg}
            />
            <Video content="Transforming Raw Data to Real Results" />
            <AboutFive
                mainContent={data2.dataAnalytics.mainContent}
                subTitle={data2.dataAnalytics.subTitle}
                title={data2.dataAnalytics.title}
                backgroundImg={data2.dataAnalytics.backgroundImg} foregroundImg={data2.dataAnalytics.foregroundImg}
            />
            {/*<TestimonialContainer classOption="bg-primary-blue" />*/}
            <CallToActionThree titleContent="Turn Data into Actionable Insights" />
            <Footer />
            <ScrollToTop />
        </React.Fragment>
    )
}

export default DataAnalytics;



